var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Container',[_c('v-flex',[_c('v-card',[_c('Header'),_c('v-card-text',[_c('v-layout',{attrs:{"row":"","grid-list-md":""}},[_c('GameDetail'),_c('ListEvent')],1)],1)],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }